// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__6hCdx","desabilitar":"OptionSelect_desabilitar__IZYBW","focado":"OptionSelect_focado__KdGdr","novo":"OptionSelect_novo__A8qOA"};